// @deprecated (initFeaturesSlider) — slider config moved to:
//   assets/js/components/ui-components/slick-slider.js (preset "sell-more-features")
//   Template updated: templates/public/static/sell-more/main.html.twig (data-lazy-init on .features__items-wrapper)
//   NOTE: initFeaturesTabs (scroll-based tab sync) below is still active.

export default class SellMorePage {
  constructor() {
    this.featuresTabs = document.querySelectorAll(".features-toggle__item");
    this.featureSections = document.querySelectorAll(".features");
    this.headerOffset = 140;
  }

  init() {
    this.initFeaturesTabs();
  }

  initFeaturesTabs() {
    const featuresTabs = this.featuresTabs;
    const featureSections = this.featureSections;
    const headerOffset = this.headerOffset;

    const updateActiveTab = () => {
      const scrollPosition = window.pageYOffset;
      let activeSection = null;
      let closestTop = -Infinity;

      featureSections.forEach((section) => {
        const sectionTopAligned =
          section.getBoundingClientRect().top +
          window.pageYOffset -
          headerOffset - 1;

        if (
          scrollPosition >= sectionTopAligned &&
          sectionTopAligned > closestTop
        ) {
          closestTop = sectionTopAligned;
          activeSection = section;
        }
      });

      if (activeSection) {
        const sectionId = activeSection.getAttribute("id");

        featuresTabs.forEach((tab) => {
          tab.classList.remove("selected");

          if (tab.dataset.featuresId === sectionId) {
            tab.classList.add("selected");
          }
        });
      }
    };

    featuresTabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        featuresTabs.forEach((item) => {
          item.classList.remove("selected");
        });
        tab.classList.add("selected");

        const targetId = tab.dataset.featuresId;
        const targetSection = document.getElementById(targetId);

        if (targetSection) {
          const targetPosition =
            targetSection.getBoundingClientRect().top +
            window.pageYOffset -
            headerOffset;
          window.scrollTo({ top: targetPosition, behavior: "smooth" });
        }
      });
    });

    let _ticking = false;
    const onScroll = () => {
      if (_ticking) return;
      _ticking = true;
      requestAnimationFrame(() => {
        updateActiveTab();
        _ticking = false;
      });
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    updateActiveTab();
  }

}

document.addEventListener("DOMContentLoaded", () => {
  new SellMorePage().init();
});
